import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import MarketingTextarea from './Marketing2Textarea';
import MarketingAttachments from './Marketing2Attachments';
import ConfirmButton from '../Modal/ConfirmButton';
class MarketingEmails extends Component {

  standardRow = (email) => {
    return (
      <Row className="adminRow pointer text-left" onClick={() => this.props.onEdit(email.ID)}>
        <Col md={4}>{email.Name}</Col>
        <Col md={4}>{email.Type}</Col>
        <Col md={4}>{email.Subject}</Col>
      </Row>
    )
  }

  editRow = (email) => {
    return (
      <Row className="editRow adminRow">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="mr-2">
              <Input
                placeholder="Name"
                name="name"
                value={this.props.editEmail.name + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="select"
                name="emailTypeID"
                value={this.props.editEmail.emailTypeID}
                onChange={e => this.props.onChange(e, 'edit')}>
                <option value={0}>Select</option>
                {this.props.types.map(type => (
                  <option key={type.TypeID} value={type.TypeID}>{type.Type}</option>
                ))}
              </Input>
            </FormGroup>
          </Form>
          <Input
            className='mt-2'
            placeholder="Subject"
            name="subject"
            value={this.props.editEmail.subject + ''}
            onChange={e => this.props.onChange(e, 'edit')} />
          <MarketingTextarea
            value={this.props.editEmail.text}
            placeholder="Text"
            name="text"
            onChange={this.props.onChange}
            edit={true}
          />
        </Col>
        <Col md={4} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Email">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(email.ID)} edit="Delete Email">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
          <MarketingAttachments
            attachments={this.props.editEmail.attachments.map(attachment => attachment.FileID)}
            onChange={this.props.onChange}
            edit={true}
            files={this.props.files}
            handleRemoveAttachment={this.props.handleRemoveAttachment}
          />
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col md={8}>
          <Form inline>
            <FormGroup className="mr-2">
              Add New Email
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                placeholder="Email Template Name"
                name="name"
                value={this.props.newEmail.name + ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="select"
                name="emailTypeID"
                value={this.props.newEmail.emailTypeID}
                onChange={e => this.props.onChange(e)}>
                <option value={0}>Select</option>
                {this.props.types.map(type => (
                  <option key={type.TypeID} value={type.TypeID}>{type.Type}</option>
                ))}
              </Input>
            </FormGroup>
          </Form>
          <Input
            className='mt-2'
            placeholder="Subject"
            name="subject"
            value={this.props.newEmail.subject + ''}
            onChange={e => this.props.onChange(e)} />
          <MarketingTextarea
            value={this.props.newEmail.text}
            placeholder="Text"
            name="text"
            onChange={this.props.onChange}
            edit={false}
          />
        </Col>
        <Col md={4} className="text-right">
          <Button
            disabled={this.props.newEmail.name === '' || this.props.newEmail.subject === '' || this.props.newEmail.text === '' || parseInt(this.props.newEmail.emailTypeID) === 0}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Email</Button>
          <MarketingAttachments
            attachments={this.props.newEmail.attachments.map(attachment => attachment.FileID)}
            onChange={this.props.onChange}
            edit={false}
            files={this.props.files}
            handleRemoveAttachment={this.props.handleRemoveAttachment}

          />
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.emails.map(email => (
          <Fragment key={email.ID}>{this.props.editEmail.emailID === email.ID ? this.editRow(email) : this.standardRow(email)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );

  }
}

export default MarketingEmails;